export const downloadFile = async (fileUrl, filename) => {
  let url = '';

  try {
    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error(`Failed to download: ${filename}`);
    }

    const blob = await response.blob();
    url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);

    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    throw new Error(`Error while downloading the file: ${error.message}`);
  } finally {
    if (url) {
      window.URL.revokeObjectURL(url);
    }
  }
};